import { render, staticRenderFns } from "./RBreadcrumbs.vue?vue&type=template&id=8aac7c04&scoped=true&"
import script from "./RBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./RBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./RBreadcrumbs.vue?vue&type=style&index=0&id=8aac7c04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aac7c04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBreadcrumbs,VBreadcrumbsItem,VIcon})
